<template>
  <div class="gl-order">
    <vue-progress-bar/>

    <div class="is-hidden-mobile">
      <steps-bar
        @select="handleStepSelect"
        :steps="steps"
        :curr-step-index="this.currStepIndex"/>
    </div>

    <div v-if="errors && errors.length" class="gl-alert_padding">
      <div v-if="errors && errors.length" class="notification is-danger">
        <div><b>Ошибка</b></div>
        <div v-for="e in errors">{{e.message}}</div>
      </div>
    </div>

    <div class="step-content">
      <customer-step
        v-if="currStep.key == 'customer'"
        v-model="customer"
        @input="handleCustomerDataChange"
        :validate-errors="customerValidationErrors"
      />

      <check-step
        v-if="currStep.key == 'check'"
        :customer="customer"
        :cart="cart"
        :total-price="totalPrice"
        :total-count="totalCount"
      />

      <finish-step
        v-if="currStep.key == 'finish'"
        :order="order"
      />
    </div>

    <div v-if="!isFinish" class="buttons">
      <button
        @click="handlePrevStep()"
        v-if="!isStepFirst"
        :disabled="loading"
        class="button">
        <span class="icon">
          <icon name="arrow-left" scale="1" class="el-icon-fa"></icon>
        </span>
        <span>Назад</span>
      </button>

      <button
        @click="handleNextStep()"
        v-if="!isFinish"
        :disabled="loading || hasValidationErrors"
        :class="[{'is-loading': loading}, 'button', 'is-primary']">
        <span class="icon">
          <icon name="check" scale="1" class="el-icon-fa"></icon>
        </span>
        <span>Продолжить</span>
      </button>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState, mapActions } from 'vuex'
  import _ from 'lodash'
  import Schema from 'async-validator'
  import * as types from 'glonass/shop/site/store/mutation-types'
  import CustomerStep from './CustomerStep.vue'
  import CheckStep from './CheckStep.vue'
  import FinishStep from './FinishStep.vue'
  import StepsBar from './StepsBar.vue'
  import 'vue-awesome/icons/check'
  import 'vue-awesome/icons/arrow-left'
  import 'vue-awesome/icons/shopping-cart'
  import 'vue-awesome/icons/flag-checkered'

  const steps = [
    {key: 'customer', label: 'Ввод данных покупателя', icon: 'user'},
    {key: 'check', label: 'Проверка заказа', icon: 'check'},
    {key: 'finish', label: 'Завершение', icon: 'flag-checkered'}
  ]

  const customerValidator = new Schema({
    last_name: {type: 'string', required: true},
    first_name: {type: 'string', required: true},
    middle_name: {type: 'string', required: true},
    email: {type: 'email', required: true},
    phone: {type: 'string', required: true}
  })

  /**
   * Форма оформления заказа.
   */
  export default {
    name: 'order',

    data () {
      return {
        customerValidator,
        customerValidationErrors: {
          fictive: true
        },

        steps,
        currStepIndex: 0,
        customer: {
          last_name: '',
          first_name: '',
          middle_name: '',
          phone: '',
          email: ''
        }
      }
    },

    watch: {
      success () {
        // todo:
        this.currStepIndex = 2
      },

      loading () {
        this.loading ? this.$Progress.start() : this.$Progress.finish()
      }
    },

    methods: {
      ...mapActions('shop', [
        'createOrder'
      ]),

      handleCustomerDataChange (value) {
        // watcher не работает для внутренних полей
        this.validateCustomer(value)
      },

      handlePrevStep () {
        if (this.isStepFirst) {
          throw new Error('move to prev, when current step is first')
        }

        this.currStepIndex = this.currStepIndex - 1
      },

      handleStepSelect (index) {
        this.currStepIndex = index
      },

      handleNextStep () {
        if (this.isFinish) {
          throw new Error('move to next, when current step is last')
        }

        if (this.currStep.key === 'check') {
          // сохранение заказа
          // пока передаем только данные о покупателе, в дальнейшем массив будет содержать и другие данные
          this.createOrder({customer: this.customer})
        } else {
          this.currStepIndex = this.currStepIndex + 1
        }
      },

      getStep (index) {
        if (steps[index] === undefined) {
          throw new Error('Wrong step index')
        }

        return steps[index]
      },

      validateCustomer (value) {
        this.customerValidator.validate(value, (errors, fields) => {
          this.customerValidationErrors = fields || {}
        })
      }
    },

    computed: {
      ...mapState('shop', {
        cart: state => state.cart,
        order: state => state.order,
        loading: state => !!state.loading[types.CREATE_ORDER],
        success: state => state.success[types.CREATE_ORDER],
        errors: state => state.errors[types.CREATE_ORDER]
      }),

      ...mapGetters('shop', [
        'totalCount',
        'totalPrice'
      ]),

      currStep () {
        return this.getStep(this.currStepIndex)
      },

      isStepFirst () {
        return this.currStepIndex === 0
      },

      isFinish () {
        return this.currStep.key === 'finish'
      },

      hasValidationErrors () {
        return !_.isEmpty(this.customerValidationErrors)
      }
    },

    components: {
      CustomerStep,
      CheckStep,
      FinishStep,
      StepsBar
    }
  }
</script>

<style scoped lang="scss">
  .step-content {
    margin-bottom: 2rem;
  }
</style>



// WEBPACK FOOTER //
// Widget.vue?4f9de8d2